import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';

import { FileTypeSinkAdapter } from 'app/model/adapters/activities/copysink/file-type.sink.adapter';
import { AzureDataLakeStoreSink } from 'app/model/pipeline/copysink/azuredatalakestore.copysink';
import { Activity } from 'app/model/pipeline/activity';
import { Owned } from 'app/model/base/named';
import { CopySinkAdapter } from './copysink.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AzureDataLakeStoreSink),
    asynchronous: true,
    adapts: {
        type: '*',
        copyBehavior: '*',
        maxConcurrentConnections: '*',
        structure: '*'
    }
})
export class AzureDataLakeStoreSinkAdapter extends CopySinkAdapter<
    AzureDataLakeStoreSink,
    Model.AzureDataLakeStoreSink
> {
    protected override async _toResource(model: AzureDataLakeStoreSink): Promise<Model.AzureDataLakeStoreSink> {
        const result: Model.AzureDataLakeStoreSink = {
            type: 'AzureDataLakeStoreSink'
        };
        FileTypeSinkAdapter.toSinkResource(model, result);
        CopySinkAdapter.toCommonCopySinkResource(model, result, this.context);
        return result;
    }

    protected override async _toModel(
        resource: Model.AzureDataLakeStoreSink,
        owner: Activity
    ): Promise<AzureDataLakeStoreSink> {
        const result = Owned.create<AzureDataLakeStoreSink>(Metamodel.modelFor(AzureDataLakeStoreSink), owner);
        FileTypeSinkAdapter.toSinkModel(resource, result);
        CopySinkAdapter.toCommonCopySinkModel(result, resource);
        return result;
    }
}
